import styled from 'styled-components';

export const StyledImageCropper = styled.div`
  .main-section {
    margin: 0 auto;
    text-align: center;
  }
`;
